import * as api from '../api/builderplan';

import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const BUILDER_PLANS_SEARCH = createRequestTypes(
  'APPRAISAL/BUILDER_PLANS_SEARCH',
);

export const searchBuilderPlans = makeApiActionCreatorV3(
  api.searchBuilderPlans,
  BUILDER_PLANS_SEARCH[START],
  BUILDER_PLANS_SEARCH[SUCCESS],
  BUILDER_PLANS_SEARCH[ERROR],
);

export const BUILDER_PLANS_SEARCH_RESET =
  'APPRAISAL/BUILDER_PLANS_SEARCH_RESET';

export const builderPlansSearchReset = () => ({
  type: BUILDER_PLANS_SEARCH_RESET,
});

export const GET_SEARCH_CONFIGS_FOR_BP = createRequestTypes(
  'APPRAISAL/GET_SEARCH_CONFIGS_FOR_BP',
);

export const fetchSearchConfigsForBP = makeApiActionCreatorV3(
  api.fetchSearchConfigsForBuilderPlan,
  GET_SEARCH_CONFIGS_FOR_BP[START],
  GET_SEARCH_CONFIGS_FOR_BP[SUCCESS],
  GET_SEARCH_CONFIGS_FOR_BP[ERROR],
);

export const FETCH_BUILDER_NAMES = createRequestTypes(
  'APPRAISAL/FETCH_BUILDER_NAMES',
);

export const fetchBuilderNames = makeApiActionCreatorV3(
  api.fetchBuilderNames,
  FETCH_BUILDER_NAMES[START],
  FETCH_BUILDER_NAMES[SUCCESS],
  FETCH_BUILDER_NAMES[ERROR],
);

export const INSERT_BUILDER_PLAN = createRequestTypes(
  'APPRAISAL/INSERT_BUILDER_PLAN',
);

export const insertBuilderPlan = makeApiActionCreatorV3(
  api.insertBuilderPlan,
  INSERT_BUILDER_PLAN[START],
  INSERT_BUILDER_PLAN[SUCCESS],
  INSERT_BUILDER_PLAN[ERROR],
);

export const FETCH_BUILDER_PLAN = createRequestTypes(
  'APPRAISAL/FETCH_BUILDER_PLAN',
);

export const fetchBuilderPlan = makeApiActionCreatorV3(
  api.fetchBuilderPlan,
  FETCH_BUILDER_PLAN[START],
  FETCH_BUILDER_PLAN[SUCCESS],
  FETCH_BUILDER_PLAN[ERROR],
);

export const UPDATE_BUILDER_PLAN = createRequestTypes(
  'APPRAISAL/UPDATE_BUILDER_PLAN',
);

export const updateBuilderPlan = makeApiActionCreatorV3(
  api.updateBuilderPlan,
  UPDATE_BUILDER_PLAN[START],
  UPDATE_BUILDER_PLAN[SUCCESS],
  UPDATE_BUILDER_PLAN[ERROR],
);

export const FETCH_BUILDER_PLAN_SKETCH = createRequestTypes(
  'APPRAISAL/FETCH_BUILDER_PLAN_SKETCH',
);

export const fetchBuilderPlanSketch = makeApiActionCreatorV3(
  api.fetchBuilderPlanSketch,
  FETCH_BUILDER_PLAN_SKETCH[START],
  FETCH_BUILDER_PLAN_SKETCH[SUCCESS],
  FETCH_BUILDER_PLAN_SKETCH[ERROR],
);

export const COPY_COST_APPROACH_FROM_VALUATION = createRequestTypes(
  'APPRAISAL/COPY_COST_APPROACH_FROM_VALUATION',
);

export const copyCostApproachFromValuation = makeApiActionCreatorV3(
  api.copyCostApproachFromValuation,
  COPY_COST_APPROACH_FROM_VALUATION[START],
  COPY_COST_APPROACH_FROM_VALUATION[SUCCESS],
  COPY_COST_APPROACH_FROM_VALUATION[ERROR],
);

export const FETCH_BUILDER_PLAN_VALUATION = createRequestTypes(
  'APPRAISAL/FETCH_BUILDER_PLAN_VALUATION',
);

export const fetchBuilderPlanValuation = makeApiActionCreatorV3(
  api.fetchBuilderPlanValuation,
  FETCH_BUILDER_PLAN_VALUATION[START],
  FETCH_BUILDER_PLAN_VALUATION[SUCCESS],
  FETCH_BUILDER_PLAN_VALUATION[ERROR],
);

export const DELETE_BUILDER_PLAN = createRequestTypes(
  'APPRAISAL/DELETE_BUILDER_PLAN',
);

export const deleteBuilderPlan = makeApiActionCreatorV3(
  api.deleteBuilderPlan,
  DELETE_BUILDER_PLAN[START],
  DELETE_BUILDER_PLAN[SUCCESS],
  DELETE_BUILDER_PLAN[ERROR],
);

export const SET_SEARCH_FORM_DATA = `APPRAISAL/SET_SEARCH_FORM_DATA`;
export const setFormData = (formData) => ({
  type: SET_SEARCH_FORM_DATA,
  payload: formData,
});

export const CHANGE_PAGE = `APPRAISAL/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `APPRAISAL/CHANGE_ROWS_PER_PAGE`;

export const changePage = (page) => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = (rowsPerPage) => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});
